module.exports = __webpack_public_path__ + "img/12.92f865ea.jpg";